<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-3">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <div>
                                    <h1 class="h4 ls-tight">Usuario - {{ data.type }}{{ data.id }}</h1>
                                    <p class="text-sm text-muted mb-0">Administre los roles de su cuenta y otorgue a sus
                                administradores solo los permisos necesarios.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-auto col-12 mt-4 mt-sm-0">
                            <div class="hstack gap-2 justify-content-sm-end">
                                <router-link :to="{ name: 'UserUpdate', params: { role: role, id: data.id } }">
                                    <button type="button" class="btn btn-h btn-primary px-3">
                                        <span>Editar</span>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div class="w-100 pt-5" v-if="loading">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-lg-6">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Tipo de cuenta: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <v-select v-model="data.account_type"
                                        :items="accounts"
                                        hide-details
                                        readonly
                                        class="form-control form-control-sm">
                                    </v-select>
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Nombre: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm bg-white text-hover" v-model="data.name">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Correo electrónico: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="email" readonly class="form-control form-control-sm bg-white text-hover" v-model="data.email">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Código: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm bg-white text-hover" :value="`${data.type}${data.id}`">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Identificación: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm bg-white text-hover" v-model="data.identification">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Estado: </small>
                                <div class="ml-2 d-flex" style="width: calc(100% - 140px);">
                                    <div style="width: 10%;" class="d-flex">
                                        <span class="badge badge-pill" :class="data.enabled ? 'badge-success' : 'badge-danger'"><small>{{ data.enabled ? 'Si' : 'No'}}</small></span>
                                    </div>
                                    <div class="d-flex ml-2 align-items-center" style="width: calc(100% - 10%);">
                                        <div class="w-50 d-flex">
                                            <small class="input-title mb-0">Cuenta Completa: </small>
                                            <span class="badge badge-pill ml-2" :class="data.complete ? 'badge-success' : 'badge-danger'"><small>{{ data.complete ? 'Si' : 'No'}}</small></span>
                                        </div>
                                        <div class="w-50 d-flex">
                                            <small class="input-title mb-0">Verificado: </small>
                                            <span class="badge badge-pill ml-2" :class="data.email_verified_at ? 'badge-success' : 'badge-danger'"><small>{{ data.email_verified_at ? 'Si' : 'No'}}</small></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Fecha de afiliación: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm bg-white text-hover" :value="data.created_at | DATE">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="mb-2">Dirección de entrega</h5>
                                    <div class="d-flex align-items-center"><i class="bi bi-geo-alt me-2 text-muted"></i> <span class="text-sm text-heading text-primary-hover" v-html="data.address_or_branch"></span></div>
                                    <div class="d-flex align-items-center"><i class="bi bi-telephone me-2 text-muted"></i> <span class="text-sm text-heading text-primary-hover">{{ data.phone }}/{{ data.mobil }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <packages/>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
import Packages from './table/Packages'
export default {
    components: { Packages },
    data() {
        return {
            loading: true,
            data: {},
            id: this.$route.params.id,
            role: this.$route.params.role,
            mapStyle: {},
            accounts: [
                { value: 0, text: 'Sistema' },
                { value: 1, text: 'Personal' },
                { value: 2, text: 'Empresarial' },
            ]
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/users/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/users/Detail.vue